export const capitalize = (str: string): string =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const isInteger = (str: string): boolean =>
  Number.isInteger(Number(str));

export const isChar = (str: string): boolean => str.length === 1;

export const isEllipsis = (str: string): boolean => str === '...';
